module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Keyboard-588aa3baa998bdc61dd11f3aaaa4602f.svg";